import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import InvoiceWithToken from 'components/public/InvoiceWithToken/InvoiceWithToken';

const InstantAuth = withLazyFallback(
  () => import('components/InstantActions/components/InstantAuth')
);
const InstantPacket = withLazyFallback(
  () => import('components/InstantActions/components/InstantPacket')
);
const InstantActionPage = withLazyFallback(() => import('components/InstantActions/wrapper'));
const LinkExited = withLazyFallback(
  () => import('components/InstantActions/components/LinkExited/LinkExited')
);
const StandalonePayment = withLazyFallback(
  () => import('components/public/StandalonePayment/StandalonePayment')
);

const INSTANT = [
  { path: 'ia/:token', element: <InstantActionPage /> },
  { path: 'ia/auth/:token', element: <InstantAuth /> },
  { path: 'exited', element: <LinkExited />, handle: { title: 'Exited' } },
  { path: 'invoice/:token', element: <InvoiceWithToken /> },
  { path: 'pay/:paymentLinkKey', element: <StandalonePayment />, handle: { title: 'Pay' } },
  { path: 'instant-packet', element: <InstantPacket /> },
  { path: 'instant-packet/:step_id', element: <InstantPacket /> },
  { path: 'instant-packet/:step_id/:substep_id', element: <InstantPacket /> }
];

export default INSTANT;
